import { TaskImportServiceEnum } from "@/enums";
import { ITirPmDropdownOption } from "tir-components";

export class TaskImportDropdownOptionModel implements ITirPmDropdownOption {
  /**ID опции */
  Id: TaskImportServiceEnum;
  /**Текст */
  Text: string;

  constructor(obj?: Partial<TaskImportDropdownOptionModel>) {
    Object.assign(this, obj);
  }
}
